export interface AbTestConfiguration {
  id: string
  scopeId: string
  name: string
  variants: Array<{ variant: string }>
  active: boolean
}

/** What a client sends to create a test: the server sets the id and the scope, and a new test starts disabled. */
export type AbTestConfigurationInput = Pick<AbTestConfiguration, 'name' | 'variants'>

export const AB_TEST_MIN_VARIANTS = 2
export const AB_TEST_MAX_VARIANTS = 4
/** A variant ends up quoted in the `<meta content="…">` and `setTargeting('…')` snippets the publisher copies. */
export const AB_TEST_VARIANT_PATTERN = /^[^'"/\\]+$/
